
export type RestaurantStatus = 'open' | 'closing_soon' | 'closed';

export interface RestaurantStatusInfo {
  status: RestaurantStatus;
  statusText: string;
  statusColor: string;
  canOrder: boolean;
}

// Properly get Gambia time (GMT/UTC+0)
const getGambiaTime = () => {
  // Create a new date and convert to Gambia timezone
  const now = new Date();
  const gambiaTime = new Date(now.toLocaleString("en-US", {timeZone: "Africa/Banjul"}));
  return gambiaTime;
};

export const getRestaurantStatus = (restaurant: any): RestaurantStatusInfo => {
  // First check if restaurant is manually closed by the vendor
  if (!restaurant.is_open) {
    return {
      status: 'closed',
      statusText: 'Closed',
      statusColor: 'bg-red-500',
      canOrder: false
    };
  }

  // If restaurant is marked as open, check business hours for "closing soon" status
  if (restaurant.opening_hours) {
    const gambiaTime = getGambiaTime();
    const currentDay = gambiaTime.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
    const currentTime = gambiaTime.toLocaleTimeString('en-US', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit'
    }); // HH:MM format
    
    console.log('Gambia current time:', currentTime, 'Day:', currentDay);
    
    const dayHours = restaurant.opening_hours[currentDay];
    
    // If today is marked as closed in business hours, show closed
    if (dayHours && !dayHours.isOpen) {
      return {
        status: 'closed',
        statusText: 'Closed',
        statusColor: 'bg-red-500',
        canOrder: false
      };
    }
    
    // If today should be open, check if it's closing soon
    if (dayHours && dayHours.isOpen && dayHours.closeTime) {
      // Check if current time is past closing time
      if (currentTime > dayHours.closeTime) {
        return {
          status: 'closed',
          statusText: 'Closed',
          statusColor: 'bg-red-500',
          canOrder: false
        };
      }
      
      // Check if current time is before opening time
      if (dayHours.openTime && currentTime < dayHours.openTime) {
        return {
          status: 'closed',
          statusText: 'Closed',
          statusColor: 'bg-red-500',
          canOrder: false
        };
      }
      
      // Calculate if restaurant is closing within 45 minutes using Gambia time
      const closeTime = new Date();
      const [closeHour, closeMinute] = dayHours.closeTime.split(':');
      closeTime.setHours(parseInt(closeHour), parseInt(closeMinute), 0, 0);
      
      // Convert to Gambia timezone for comparison
      const gambiaCloseTime = new Date(closeTime.toLocaleString("en-US", {timeZone: "Africa/Banjul"}));
      const timeDiff = gambiaCloseTime.getTime() - gambiaTime.getTime();
      const minutesUntilClose = timeDiff / (1000 * 60);
      
      console.log('Minutes until close:', minutesUntilClose);
      
      if (minutesUntilClose <= 45 && minutesUntilClose > 0) {
        return {
          status: 'closing_soon',
          statusText: 'Closing Soon',
          statusColor: 'bg-yellow-500',
          canOrder: true
        };
      }
    }
  }

  // If restaurant is marked as open and within business hours (or no business hours set)
  return {
    status: 'open',
    statusText: 'Open',
    statusColor: 'bg-green-500',
    canOrder: true
  };
};
